import React, { ReactElement } from 'react';
import { ProductBox } from 'b2b-apps/shop/common/components/ProductBox';
import { Props } from './';

const ProductGroup = ({
  skus,
  productTiles,
  onProductClick,
  onProductAddToCart,
  styleType,
  absolutePosition = 0,
  isForSlider,
  isFromContentList,
  className,
}: Props): ReactElement => (
  <>
    {
      skus.map(
        (sku: string, index): ReactElement => {
          const listPosition = absolutePosition + index + 1;

          return (
            <ProductBox
              sku={sku}
              product={productTiles[sku]}
              styleType={styleType}
              isForSlider={isForSlider}
              isFromContentList={isFromContentList}
              className={className}
              onClick={(sku) => onProductClick(sku, listPosition)}
              onAddToCart={(sku) => onProductAddToCart(sku, listPosition)}
              key={sku}
            />
          );
        },
      )
    }
  </>
);

export { ProductGroup };
